import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';

import { router } from './router';
import { SessionProvider } from '@/shared/auth/SessionProvider';
import { ActiveCountryProvider } from '@/shared/countries/ActiveCountryProvider';
import { TooltipProvider } from '@/shared/components/ui/tooltip';
import './shared/locales/i18n';
import './styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ActiveCountryProvider>
          <TooltipProvider delayDuration={200}>
            <RouterProvider router={router} />
          </TooltipProvider>
          <Toaster richColors position="top-right" />
        </ActiveCountryProvider>
      </SessionProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
